export const FavouriteTypeList = { YES: 'yes', NO: 'no' };
